// state
const state = {
  listVisualization: null
}

// getters
const getters = {
  getListVisualization (state) {
    return state.listVisualization
  }
}

// actions
const actions = {
  // Update Visualization
  updateListVisualization ({commit}) {
    const store = this
    let dataService = {
      method: 'GET',
      endpoint: '/api/parksAndGardens/visualizations',
      data: null,
      mutation: 'UPDATE_LIST_VISUALIZATION'
    }
    store.dispatch('callService', dataService)
  }
}

// mutations
const mutations = {
  UPDATE_LIST_VISUALIZATION (state, data) {
    state.listVisualization = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboardVisualization.js